import HeaderProvider from '@Providers/HeaderProvider';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import SecondaryNavigation from './SecondaryNavigation';
import { Outlet } from '@tanstack/react-router';

const MainLayout: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <SecondaryNavigation open={open} onClose={() => setOpen(false)} />
            <Box
                display="flex"
                flexDirection="column"
                flex={1}
                px={3}
                minWidth={0}
            >
                <HeaderProvider openNav={() => setOpen(true)}>
                    <Box
                        id="main-content"
                        flex={1}
                        overflow="auto"
                        display="flex"
                        flexDirection="column"
                        pb={3}
                    >
                        <Outlet />
                    </Box>
                </HeaderProvider>
            </Box>
        </>
    );
};

export default MainLayout;
